import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTopPage() {
  // GET LOCATION PATHNAME TO ADD WINDOW ZERO WHEN ROUTE PAGES
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTopPage;
